// extracted by mini-css-extract-plugin
export var container = "_5t-0";
export var disabled = "_5t-4";
export var fullWidth = "_5t-3";
export var lined = "_5t-1";
export var selected = "_5t-5";
export var tab = "_5t-2";